"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
const theme_1 = require("../../styles/theme");
const TrashIcon = (props) => {
    return (react_1.default.createElement(core_1.SvgIcon, Object.assign({ viewBox: "0 0 48 48" }, props),
        react_1.default.createElement("path", { fill: "#9FA8DA", d: "M11,13v25c0,2.209,1.791,4,4,4h16c2.209,0,4-1.791,4-4V13H11z" }),
        react_1.default.createElement("path", { fill: "#7986CB", d: "M22 15H24V38H22zM28 15H30V38H28zM16 15H18V38H16z" }),
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { fill: "#5C6BC0", d: "M11 10H35V14H11z" }),
            react_1.default.createElement("path", { fill: "#5C6BC0", d: "M9 13H37V17H9zM19 12V8h8v4h2V8c0-1.104-.896-2-2-2h-8c-1.104 0-2 .896-2 2v4H19z" }))));
};
const getSize = (size) => ({ height: `${size}px`, width: `${size}px`, minHeight: `${size}px` });
const TGPreviewField = props => {
    const { files, thumbnailSize, onDelete, onModal } = props;
    //sizing of elements based on the thumbnail size
    const buttonSize = Math.round(thumbnailSize / 2.8);
    const iconSize = Math.round(thumbnailSize / 3.5);
    const downloadBtnSize = Math.round(thumbnailSize / 10);
    const gap = Math.round(thumbnailSize / 14); //gap between thumbnails
    const previewSectionStyles = usePreviewSectionStyles();
    return (react_1.default.createElement(core_1.Box, { mt: 3, className: previewSectionStyles.wrapper }, files.map((file) => {
        const { id, url } = file;
        return (react_1.default.createElement("div", { style: Object.assign(Object.assign({}, getSize(thumbnailSize)), { margin: gap }), key: id, className: previewSectionStyles.previewImg },
            react_1.default.createElement("img", { src: url, alt: file.name }),
            react_1.default.createElement(core_1.Fab, { size: "small", style: getSize(buttonSize), className: previewSectionStyles.rightTopBtn, onClick: () => {
                    onDelete(id);
                } }, onModal ? react_1.default.createElement(Delete_1.default, null) : react_1.default.createElement(TrashIcon, { style: { fontSize: iconSize } })),
            onModal && (react_1.default.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", download: true },
                react_1.default.createElement(core_1.Button, { style: { fontSize: downloadBtnSize }, variant: "contained", size: "small", className: previewSectionStyles.bottomCenterBtn }, "Download")))));
    })));
};
const usePreviewSectionStyles = core_1.makeStyles((theme) => core_1.createStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    previewImg: {
        position: 'relative',
        '& img': {
            width: '100%',
            height: '100%',
        },
    },
    rightTopBtn: {
        position: 'absolute',
        top: '-10%',
        right: '-10%',
        backgroundColor: theme_1.colors.white,
        color: theme_1.colors.danger,
    },
    bottomCenterBtn: {
        position: 'absolute',
        bottom: '1%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
}));
exports.default = TGPreviewField;
//# sourceMappingURL=TGPreviewField.js.map